import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ErrorBoundary } from '@/components/common/ErrorBoundary'
import { getSubdomain } from '@/utils/subdomain'
import { router, createSubdomainRouter } from './routes'
import './styles/index.css'

// Detect subdomain before rendering
const subdomain = getSubdomain()
const activeRouter = subdomain ? createSubdomainRouter(subdomain) : router

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <RouterProvider router={activeRouter} />
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
